module.exports = __webpack_public_path__ + "static/media/1920x10803.9c382c01.png";